module.exports = __webpack_public_path__ + "static/media/arrowRight.784ce2a9.svg";